import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/login',
		name: '系统登录',
		meta: {
			requireAuth: false
		},
		component: Login,
		iconCls: 'el-icon-message'

	}

]



//创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 拦截登录，token验证
let refreshRouter = true;
router.beforeEach((to, from, next) => {
	//alert(router.options.routes.length);
	if (to.meta.requireAuth === undefined) {
		if (localStorage.getItem("token")) {
			if (refreshRouter && localStorage.getItem('MenuData')) {
				refreshRouter = false;
				let menuArr = JSON.parse(localStorage.getItem('MenuData'));
				//console.log(menuArr);
				let menuPage = [];
				menuArr.forEach(function(item, index) {
					let menuObj = {
						path: item.path,
						name: item.name,
						component: () => import('../' + item.viewPath),
						//component: resolve => require(["@/"+item.viewPath], resolve),
						iconCls: item.iconCls
					};
					if (item.children) {
						menuObj.children = [];
						item.children.forEach(function(item2, index) {
							menuObj.children.push({
								path: item2.path,
								name: item2.name,
								component: () => import('../' + item2.viewPath),
							});
						});
					};
					menuPage.push(menuObj);
				});
				router.addRoutes(menuPage);
				//router.options.routes.push(menuArr);
				next({ ...to
				}) // hack方法 确保addRoutes已完成
			}
			next();
		} else {
			next({
				path: '/login'
			})
		}
	} else {
		next();
	}
})

export default router
